export function converterUnidadeMedida(valor: number) {
  if (valor >= 1) {
    return `${valor.toFixed(2)}m`
  }
  return `${(valor * 100).toFixed(2)}cm`
}
